import { render, staticRenderFns } from "./GamesDropdown.vue?vue&type=template&id=62b65f7d"
import script from "./GamesDropdown.js?vue&type=script&lang=js&external"
export * from "./GamesDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports